import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faCoins,
  faImage,
  faPalette,
  faLeaf,
  faKey,
  faCaretDown,
  faListCheck,
} from "@fortawesome/free-solid-svg-icons";
import { BaseMenu } from "../../../components/Cart/Cart-Icon/BaseMenu";

interface AdminItem {
  to: string;
  label: string;
  icon: typeof faChartLine;
}

const ADMIN_ITEMS: AdminItem[] = [
  { to: "/admin/statistics", label: "Statistik", icon: faChartLine },
  { to: "/admin/price-import", label: "Prisimport", icon: faCoins },
  { to: "/admin/logo-import", label: "Logoimport", icon: faImage },
  { to: "/admin/design-import", label: "Designimport", icon: faPalette },
  { to: "/admin/co2", label: "CO₂-beregner", icon: faLeaf },
  { to: "/admin/orders-queue", label: "Ordrekø", icon: faListCheck },
  { to: "/admin/api-keys", label: "API-nøgler", icon: faKey },
];

export function AdminMenuDropdown(): JSX.Element {
  const [anchor, setAnchor] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchor);
  const location = useLocation();

  const visibleItems = ADMIN_ITEMS;

  const isActive = visibleItems.some((item) =>
    location.pathname.startsWith(item.to),
  );

  function handleClose() {
    setAnchor(null);
  }

  return (
    <>
      <button
        onClick={(e) => setAnchor(e.currentTarget)}
        className={`group flex items-center gap-2 px-4 h-full text-sm font-medium uppercase tracking-wide transition-colors ${
          isActive || open
            ? "text-[--primary]"
            : "text-[#596675] hover:text-[--primary]"
        }`}
      >
        <span>Admin</span>
        <FontAwesomeIcon
          icon={faCaretDown}
          className={`text-[10px] transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>
      <BaseMenu
        anchorEl={anchor}
        open={open}
        onClose={handleClose}
        MenuListProps={{ "aria-labelledby": "admin-menu" }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {visibleItems.map((item) => (
          <Link key={item.to} to={item.to} style={{ textDecoration: "none" }}>
            <MenuItem onClick={handleClose}>
              <ListItemIcon>
                <FontAwesomeIcon icon={item.icon} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{
                  style: {
                    color: location.pathname.startsWith(item.to)
                      ? "var(--primary)"
                      : "inherit",
                  },
                }}
              >
                {item.label}
              </ListItemText>
            </MenuItem>
          </Link>
        ))}
      </BaseMenu>
    </>
  );
}
